var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3" },
        [
          _c(
            "v-card",
            { staticClass: "mb-3" },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-bullhorn ")]
                  ),
                  _vm._v(
                    " Administração > Gerenciamento de Divulgações de Novidades "
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-6" },
            [
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "text-h4 primary--text font-weight-regular"
                        },
                        [_vm._v(" Gerenciamento de Divulgações de Novidades ")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-left", attrs: { cols: "8", md: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-medium",
                          attrs: {
                            color: "success",
                            large: !_vm.$vuetify.breakpoint.xs,
                            small: _vm.$vuetify.breakpoint.xs,
                            elevation: "2"
                          },
                          on: { click: _vm.novaDivulgacao }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                size: _vm.$vuetify.breakpoint.xs ? 18 : 24
                              }
                            },
                            [_vm._v("mdi-plus")]
                          ),
                          _vm._v(" Nova Divulgação ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      class: _vm.$vuetify.breakpoint.xs
                        ? "text-left pl-0"
                        : "text-right",
                      attrs: { cols: "4", md: "6" }
                    },
                    [
                      _c("v-select", {
                        style: _vm.$vuetify.breakpoint.xs
                          ? "max-width: 120px;"
                          : "max-width: 200px; margin-left: auto;",
                        attrs: {
                          items: _vm.opcoesStatus,
                          label: "Status",
                          outlined: "",
                          dense: "",
                          "hide-details": ""
                        },
                        on: { change: _vm.aplicarFiltros },
                        model: {
                          value: _vm.filtroStatus,
                          callback: function($$v) {
                            _vm.filtroStatus = $$v
                          },
                          expression: "filtroStatus"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1 responsive-table",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.divulgacoesFiltradas,
                      loading: _vm.loading,
                      options: _vm.options,
                      "server-items-length": _vm.totalItems,
                      "footer-props": {
                        itemsPerPageOptions: [5, 10, 20, 50],
                        itemsPerPageText: "Itens por página:",
                        showFirstLastPage: true,
                        showCurrentPage: true
                      },
                      "loading-text": "Carregando divulgações...",
                      "no-data-text":
                        "Nenhuma divulgação encontrada. Crie uma nova!",
                      "sort-by": "data_envio",
                      "sort-desc": "",
                      "mobile-breakpoint": "960",
                      "hide-default-footer": _vm.$vuetify.breakpoint.xs
                    },
                    on: {
                      "update:options": function($event) {
                        _vm.options = $event
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.assunto`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center subject-cell"
                                },
                                [
                                  item.imagem
                                    ? _c(
                                        "div",
                                        { staticClass: "mr-3 image-container" },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass: "subject-avatar",
                                              attrs: {
                                                size: _vm.$vuetify.breakpoint.xs
                                                  ? 32
                                                  : 40,
                                                tile: "",
                                                rounded: "4"
                                              }
                                            },
                                            [
                                              _c("v-img", {
                                                attrs: {
                                                  src: item.imagem,
                                                  "aspect-ratio": "1"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "mr-3 image-container" },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass: "subject-avatar",
                                              attrs: {
                                                size: _vm.$vuetify.breakpoint.xs
                                                  ? 32
                                                  : 40,
                                                tile: "",
                                                rounded: "4",
                                                color: "grey lighten-3"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "grey",
                                                    size: _vm.$vuetify
                                                      .breakpoint.xs
                                                      ? 16
                                                      : 20
                                                  }
                                                },
                                                [_vm._v(" mdi-image-off ")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                  _c(
                                    "div",
                                    { staticClass: "subject-content" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-decoration-none primary--text font-weight-medium cursor-pointer subject-link",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizarDivulgacao(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.assunto) + " "
                                          )
                                        ]
                                      ),
                                      item.nomeImagem &&
                                      !_vm.$vuetify.breakpoint.xs
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption grey--text image-name"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { "x-small": "" }
                                                },
                                                [_vm._v("mdi-image")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.nomeImagem) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.$vuetify.breakpoint.xs
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "mobile-status mt-1"
                                            },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    "x-small": "",
                                                    color:
                                                      item.status === "rascunho"
                                                        ? "orange"
                                                        : "green",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.status ===
                                                          "rascunho"
                                                          ? "Rascunho"
                                                          : "Enviado"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              item.enviadoVia?.email
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#1976d2",
                                                        "text-color": "white",
                                                        outlined: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            left: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-email-outline"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" Email ")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              item.enviadoVia?.popup
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "#7c4dff",
                                                        "text-color": "white",
                                                        outlined: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            left: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-message-alert-outline"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" Pop ")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !item.enviadoVia?.email &&
                                              !item.enviadoVia?.popup
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        "x-small": "",
                                                        color: "grey lighten-2",
                                                        "text-color":
                                                          "grey darken-1"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            left: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-help-circle-outline"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" N/D ")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.enviadoVia`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "methods-container",
                                  class: _vm.$vuetify.breakpoint.xs
                                    ? "d-flex flex-row"
                                    : "d-flex flex-column"
                                },
                                [
                                  item.enviadoVia?.email
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "method-chip email-chip",
                                                            class: _vm.$vuetify
                                                              .breakpoint.xs
                                                              ? "mr-1"
                                                              : "mb-1",
                                                            attrs: {
                                                              small: !_vm
                                                                .$vuetify
                                                                .breakpoint.xs,
                                                              "x-small":
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .xs,
                                                              color: "#1976d2",
                                                              "text-color":
                                                                "white",
                                                              outlined: ""
                                                            }
                                                          },
                                                          "v-chip",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "chip-icon",
                                                            attrs: {
                                                              left: "",
                                                              size: 16
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-email-outline "
                                                            )
                                                          ]
                                                        ),
                                                        !_vm.$vuetify.breakpoint
                                                          .xs
                                                          ? _c("span", [
                                                              _vm._v("E-mail")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("Email")
                                                            ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Enviado por e-mail para os usuários"
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  item.enviadoVia?.popup
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "method-chip popup-chip",
                                                            attrs: {
                                                              small: !_vm
                                                                .$vuetify
                                                                .breakpoint.xs,
                                                              "x-small":
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .xs,
                                                              color: "#7c4dff",
                                                              "text-color":
                                                                "white",
                                                              outlined: ""
                                                            }
                                                          },
                                                          "v-chip",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "chip-icon",
                                                            attrs: {
                                                              left: "",
                                                              size: 16
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-message-alert-outline "
                                                            )
                                                          ]
                                                        ),
                                                        !_vm.$vuetify.breakpoint
                                                          .xs
                                                          ? _c("span", [
                                                              _vm._v("Pop-up")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("Pop")
                                                            ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Exibido como pop-up na plataforma"
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  !item.enviadoVia?.email &&
                                  !item.enviadoVia?.popup
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "method-undefined"
                                                      },
                                                      [
                                                        _c(
                                                          "v-chip",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "method-chip undefined-chip",
                                                                attrs: {
                                                                  small: !_vm
                                                                    .$vuetify
                                                                    .breakpoint
                                                                    .xs,
                                                                  "x-small":
                                                                    _vm.$vuetify
                                                                      .breakpoint
                                                                      .xs,
                                                                  color:
                                                                    "grey lighten-2",
                                                                  "text-color":
                                                                    "grey darken-1"
                                                                }
                                                              },
                                                              "v-chip",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "chip-icon",
                                                                attrs: {
                                                                  left: "",
                                                                  size: 16
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " mdi-help-circle-outline "
                                                                )
                                                              ]
                                                            ),
                                                            !_vm.$vuetify
                                                              .breakpoint.xs
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "Não definido"
                                                                  )
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v("N/D")
                                                                ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Métodos de envio não foram definidos"
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: `item.data_envio`,
                          fn: function({ item }) {
                            return [
                              item.status === "rascunho"
                                ? _c("span", { staticClass: "grey--text" }, [
                                    _vm._v(" Rascunho ")
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatarData(item.dataEnvio)
                                        ) +
                                        " "
                                    )
                                  ])
                            ]
                          }
                        },
                        {
                          key: `item.expira_em`,
                          fn: function({ item }) {
                            return [
                              item.expira_em
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            color: _vm.getStatusExpiracaoColor(
                                              item.expira_em
                                            ),
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getStatusExpiracaoIcon(
                                                  item.expira_em
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "font-weight-medium",
                                            class:
                                              _vm.getStatusExpiracaoColor(
                                                item.expira_em
                                              ) + "--text"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatarDataExpiracao(
                                                    item.expira_em
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _vm.getTempoParaExpiracao(
                                          item.expira_em
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "caption grey--text"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getTempoParaExpiracao(
                                                        item.expira_em
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "grey--text" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1 grey--text",
                                          attrs: { small: "" }
                                        },
                                        [_vm._v("mdi-infinity")]
                                      ),
                                      _vm._v(" Sem expiração ")
                                    ],
                                    1
                                  )
                            ]
                          }
                        },
                        {
                          key: `item.acoes`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "font-weight-medium action-btn",
                                  attrs: {
                                    color: "primary",
                                    small: !_vm.$vuetify.breakpoint.xs,
                                    "x-small": _vm.$vuetify.breakpoint.xs,
                                    outlined: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.visualizarDivulgacao(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                        small: !_vm.$vuetify.breakpoint.xs,
                                        "x-small": _vm.$vuetify.breakpoint.xs
                                      }
                                    },
                                    [_vm._v(" mdi-eye ")]
                                  ),
                                  !_vm.$vuetify.breakpoint.xs
                                    ? _c("span", [_vm._v("Visualizar")])
                                    : _c("span", [_vm._v("Ver")])
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: `header.assunto`,
                          fn: function({ header }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(" " + _vm._s(header.text) + " "),
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-arrow-up-down")
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: `header.data_envio`,
                          fn: function({ header }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "font-weight-bold" },
                                [
                                  _vm._v(" " + _vm._s(header.text) + " "),
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-arrow-up-down")
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm.$vuetify.breakpoint.xs
                    ? _c(
                        "div",
                        { staticClass: "mobile-pagination" },
                        [
                          _c("v-pagination", {
                            attrs: {
                              length: Math.ceil(
                                _vm.totalItems / _vm.options.itemsPerPage
                              ),
                              "total-visible": 5,
                              circle: ""
                            },
                            model: {
                              value: _vm.options.page,
                              callback: function($$v) {
                                _vm.$set(_vm.options, "page", $$v)
                              },
                              expression: "options.page"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "50vw", "overlay-color": "rgba(0,0,0,0.8)" },
          model: {
            value: _vm.dialogVisualizacaoImagem,
            callback: function($$v) {
              _vm.dialogVisualizacaoImagem = $$v
            },
            expression: "dialogVisualizacaoImagem"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "modal-visualizacao-imagem" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "pa-2 d-flex justify-space-between align-center"
                },
                [
                  _c("span", { staticClass: "text-h6" }, [
                    _vm._v("Visualizar Imagem")
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "close-btn",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisualizacaoImagem = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0 d-flex justify-center align-center",
                  staticStyle: { "min-height": "50vh" }
                },
                [
                  _vm.imagemVisualizacao
                    ? _c("v-img", {
                        staticClass: "imagem-fullscreen",
                        attrs: {
                          src: _vm.imagemVisualizacao,
                          contain: "",
                          "max-height": "80vh",
                          "max-width": "100%"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800px", persistent: "" },
          model: {
            value: _vm.dialogVisualizacao,
            callback: function($$v) {
              _vm.dialogVisualizacao = $$v
            },
            expression: "dialogVisualizacao"
          }
        },
        [
          _vm.divulgacaoSelecionada
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "primary white--text" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "white--text", attrs: { left: "" } },
                        [_vm._v("mdi-eye")]
                      ),
                      _vm._v(" Visualizar Divulgação "),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close-btn",
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogVisualizacao = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-6" },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h3", { staticClass: "text-h5 mb-3" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.divulgacaoSelecionada.assunto) +
                                  " "
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color:
                                      _vm.divulgacaoSelecionada.status ===
                                      "enviado"
                                        ? "success"
                                        : "grey",
                                    "text-color": "white",
                                    small: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.divulgacaoSelecionada.status ===
                                          "enviado"
                                          ? "Enviado"
                                          : "Rascunho"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-right", attrs: { cols: "6" } },
                            [
                              _c("span", { staticClass: "grey--text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.divulgacaoSelecionada.status ===
                                        "enviado"
                                        ? _vm.formatarData(
                                            _vm.divulgacaoSelecionada.dataEnvio
                                          )
                                        : "Ainda não enviado"
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-2" },
                        [
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      small: "",
                                      color: _vm.divulgacaoSelecionada.expira_em
                                        ? _vm.getStatusExpiracaoColor(
                                            _vm.divulgacaoSelecionada.expira_em
                                          )
                                        : "grey"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.divulgacaoSelecionada.expira_em
                                            ? _vm.getStatusExpiracaoIcon(
                                                _vm.divulgacaoSelecionada
                                                  .expira_em
                                              )
                                            : "mdi-infinity"
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _vm.divulgacaoSelecionada.expira_em
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-2 font-weight-medium",
                                          class:
                                            _vm.getStatusExpiracaoColor(
                                              _vm.divulgacaoSelecionada
                                                .expira_em
                                            ) + "--text"
                                        },
                                        [
                                          _vm._v(
                                            " Expira em: " +
                                              _vm._s(
                                                _vm.formatarDataExpiracao(
                                                  _vm.divulgacaoSelecionada
                                                    .expira_em
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm.getTempoParaExpiracao(
                                        _vm.divulgacaoSelecionada.expira_em
                                      )
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text ml-2"
                                            },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.getTempoParaExpiracao(
                                                      _vm.divulgacaoSelecionada
                                                        .expira_em
                                                    )
                                                  ) +
                                                  ") "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-body-2 grey--text"
                                        },
                                        [_vm._v(" Sem data de expiração ")]
                                      )
                                    ])
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm.divulgacaoSelecionada.imagem ||
                      _vm.divulgacaoSelecionada.enviadoVia
                        ? _c(
                            "v-row",
                            { staticClass: "mt-2" },
                            [
                              _vm.divulgacaoSelecionada.imagem
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-3",
                                          staticStyle: {
                                            "min-height": "120px"
                                          },
                                          attrs: { outlined: "" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-subtitle2 mb-2"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { small: "" }
                                                },
                                                [_vm._v("mdi-image")]
                                              ),
                                              _vm._v(" Imagem da Divulgação ")
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-space-between"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center"
                                                },
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass: "mr-3",
                                                      attrs: {
                                                        size: "60",
                                                        tile: "",
                                                        rounded: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src:
                                                            _vm
                                                              .divulgacaoSelecionada
                                                              .imagem,
                                                          "aspect-ratio": "1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-body-2 font-weight-medium"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .divulgacaoSelecionada
                                                                .nomeImagem ||
                                                                "Imagem anexada"
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Anexo da divulgação "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.divulgacaoSelecionada.enviadoVia
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "pa-3",
                                          staticStyle: {
                                            "min-height": "120px"
                                          },
                                          attrs: { outlined: "" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "text-subtitle2 mb-2"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { small: "" }
                                                },
                                                [_vm._v("mdi-send")]
                                              ),
                                              _vm._v(" Métodos de Envio ")
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-wrap gap-2"
                                            },
                                            [
                                              _vm.divulgacaoSelecionada
                                                .enviadoVia?.email
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "mr-2 mb-1",
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                        "text-color": "white"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            left: ""
                                                          }
                                                        },
                                                        [_vm._v("mdi-email")]
                                                      ),
                                                      _vm._v(" E-mail ")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.divulgacaoSelecionada
                                                .enviadoVia?.popup
                                                ? _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "mb-1",
                                                      attrs: {
                                                        small: "",
                                                        color: "secondary",
                                                        "text-color": "white"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            left: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-message-alert"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " Pop-up no Sistema "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          !_vm.divulgacaoSelecionada.enviadoVia
                                            ?.email &&
                                          !_vm.divulgacaoSelecionada.enviadoVia
                                            ?.popup
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "grey--text text-body-2"
                                                },
                                                [
                                                  _vm._v(
                                                    " Nenhum método de envio definido "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-divider", { staticClass: "my-4" }),
                      _c(
                        "div",
                        { staticClass: "divulgacao-info" },
                        [
                          _c(
                            "div",
                            { staticClass: "text-subtitle2 mb-3" },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("mdi-information")]
                              ),
                              _vm._v(" Detalhes da Divulgação ")
                            ],
                            1
                          ),
                          _c(
                            "v-card",
                            { staticClass: "pa-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _vm.divulgacaoSelecionada.imagem
                                        ? _c(
                                            "div",
                                            { staticClass: "mr-4" },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  attrs: {
                                                    size: "80",
                                                    tile: "",
                                                    rounded: "8"
                                                  }
                                                },
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src:
                                                        _vm
                                                          .divulgacaoSelecionada
                                                          .imagem,
                                                      "aspect-ratio": "1"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "mr-4" },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  attrs: {
                                                    size: "80",
                                                    tile: "",
                                                    rounded: "8",
                                                    color: "grey lighten-3"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "grey",
                                                        size: "40"
                                                      }
                                                    },
                                                    [_vm._v("mdi-image-off")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-h6 font-weight-medium mb-2"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.divulgacaoSelecionada
                                                      .assunto
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm.divulgacaoSelecionada.nomeImagem
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" }
                                                    },
                                                    [_vm._v("mdi-attachment")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm
                                                          .divulgacaoSelecionada
                                                          .nomeImagem
                                                      ) +
                                                      " "
                                                  )
                                                ],
                                                1
                                              )
                                            : !_vm.divulgacaoSelecionada.imagem
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text"
                                                },
                                                [
                                                  _vm._v(
                                                    " Nenhuma imagem anexada "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.divulgacaoSelecionada.imagem
                                ? _c(
                                    "div",
                                    { staticClass: "mt-3 text-center" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-visualizar-imagem",
                                          attrs: {
                                            color: "primary",
                                            small: !_vm.$vuetify.breakpoint.xs,
                                            "x-small":
                                              _vm.$vuetify.breakpoint.xs
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizarImagemCompleta(
                                                _vm.divulgacaoSelecionada.imagem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                small: !_vm.$vuetify.breakpoint
                                                  .xs,
                                                "x-small":
                                                  _vm.$vuetify.breakpoint.xs
                                              }
                                            },
                                            [_vm._v(" mdi-magnify-plus ")]
                                          ),
                                          !_vm.$vuetify.breakpoint.xs
                                            ? _c("span", [
                                                _vm._v("Visualizar Imagem")
                                              ])
                                            : _c("span", [_vm._v("Ver")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.divulgacaoSelecionada.destinatariosAdicionais &&
                      _vm.divulgacaoSelecionada.destinatariosAdicionais.length >
                        0
                        ? _c(
                            "div",
                            { staticClass: "destinatarios-adicionais mt-4" },
                            [
                              _c("v-divider", { staticClass: "mb-4" }),
                              _c(
                                "div",
                                { staticClass: "text-subtitle2 mb-3" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { small: "" }
                                    },
                                    [_vm._v("mdi-account-multiple-plus")]
                                  ),
                                  _vm._v(
                                    " Destinatários Adicionais (" +
                                      _vm._s(
                                        _vm.divulgacaoSelecionada
                                          .destinatariosAdicionais.length
                                      ) +
                                      ") "
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-0",
                                  attrs: { outlined: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "destinatarios-table-container"
                                    },
                                    [
                                      _c("v-simple-table", {
                                        attrs: { dense: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function() {
                                                return [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left font-weight-bold"
                                                        },
                                                        [_vm._v(" # ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-left font-weight-bold"
                                                        },
                                                        [_vm._v(" E-mail ")]
                                                      )
                                                    ])
                                                  ]),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.divulgacaoSelecionada
                                                        .destinatariosAdicionais,
                                                      function(email, index) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "destinatario-row"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-caption grey--text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      index + 1
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-body-2"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1 grey--text",
                                                                    attrs: {
                                                                      "x-small":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-email-outline"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      email
                                                                    ) +
                                                                    " "
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          false,
                                          3339660324
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "pa-4" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            color: "grey",
                            text: "",
                            block: _vm.$vuetify.breakpoint.xs,
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.dialogVisualizacao = false
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-close")
                          ]),
                          _vm._v(" Fechar ")
                        ],
                        1
                      ),
                      _vm.divulgacaoSelecionada.status === "rascunho"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-editar font-weight-medium",
                              attrs: {
                                color: "primary",
                                elevation: "2",
                                block: _vm.$vuetify.breakpoint.xs,
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.editarDivulgacao(
                                    _vm.divulgacaoSelecionada
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-pencil")
                              ]),
                              _vm._v(" Editar Rascunho ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "1200px",
            persistent: "",
            "overlay-color": "rgba(0,0,0,0.75)",
            transition: "dialog-bottom-transition",
            fullscreen:
              _vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm,
            scrollable: ""
          },
          model: {
            value: _vm.dialogNovaDivulgacao,
            callback: function($$v) {
              _vm.dialogNovaDivulgacao = $$v
            },
            expression: "dialogNovaDivulgacao"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "modal-nova-divulgacao" },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "modal-header d-flex align-center justify-space-between pa-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "header-content d-flex align-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "header-icon" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "32", color: "primary" } },
                            [_vm._v("mdi-bullhorn")]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text ml-3" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "text-h5 font-weight-bold primary--text mb-1"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.modoEdicao
                                    ? "Editar Divulgação"
                                    : "Nova Divulgação"
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "p",
                          { staticClass: "text-body-2 grey--text ma-0" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.modoEdicao
                                    ? "Edite os dados da sua divulgação"
                                    : "Crie e envie uma nova divulgação para os usuários"
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "close-btn",
                      attrs: { icon: "", large: "" },
                      on: { click: _vm.cancelarModal }
                    },
                    [
                      _c("v-icon", { attrs: { size: "24" } }, [
                        _vm._v("mdi-close")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "progress-indicator pa-4 pb-0" },
                [
                  _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      staticStyle: { "box-shadow": "none" },
                      attrs: { "alt-labels": "", flat: "" },
                      model: {
                        value: _vm.stepAtual,
                        callback: function($$v) {
                          _vm.stepAtual = $$v
                        },
                        expression: "stepAtual"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        {
                          staticClass: "elevation-0",
                          staticStyle: { "box-shadow": "none" }
                        },
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.stepAtual > 1,
                                step: "1",
                                color: "primary",
                                "complete-icon": "mdi-check"
                              }
                            },
                            [_vm._v(" Conteúdo ")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.stepAtual > 2,
                                step: "2",
                                color: "primary",
                                "complete-icon": "mdi-check"
                              }
                            },
                            [_vm._v(" Destinatários ")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                step: "3",
                                color: "primary",
                                "complete-icon": "mdi-check"
                              }
                            },
                            [_vm._v(" Revisão ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pa-0" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepAtual === 1,
                        expression: "stepAtual === 1"
                      }
                    ],
                    staticClass: "step-content pa-6"
                  },
                  [
                    _c("div", { staticClass: "step-title mb-4" }, [
                      _c("h3", { staticClass: "text-h6 font-weight-medium" }, [
                        _vm._v(" Defina o conteúdo da divulgação ")
                      ]),
                      _c("p", { staticClass: "text-body-2 grey--text mt-1" }, [
                        _vm._v(
                          " Adicione o assunto e a imagem que será enviada "
                        )
                      ])
                    ]),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c(
                                "label",
                                { staticClass: "field-label" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "primary" }
                                    },
                                    [_vm._v("mdi-format-title")]
                                  ),
                                  _vm._v(" Assunto * ")
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                staticClass: "mt-2",
                                attrs: {
                                  placeholder:
                                    "Ex: Novidades da Plataforma — Atualização v2.0",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  counter: "100",
                                  maxlength: "100",
                                  rules: [v => !!v || "Assunto é obrigatório"]
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "grey"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "mdi-help-circle"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Título que aparecerá no email e popup"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.novaDivulgacaoForm.assunto,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.novaDivulgacaoForm,
                                      "assunto",
                                      $$v
                                    )
                                  },
                                  expression: "novaDivulgacaoForm.assunto"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c(
                                "label",
                                { staticClass: "field-label" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "primary" }
                                    },
                                    [_vm._v("mdi-calendar-clock")]
                                  ),
                                  _vm._v(" Duração da Divulgação * ")
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                staticClass: "mt-2",
                                attrs: {
                                  type: "datetime-local",
                                  label: "Data e hora de expiração",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  rules: [
                                    v =>
                                      !!v || "Data de expiração é obrigatória",
                                    v =>
                                      new Date(v) > new Date() ||
                                      "Data deve ser no futuro"
                                  ],
                                  min: new Date().toISOString().substr(0, 16)
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "grey"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "mdi-help-circle"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Data e hora em que a divulgação expirará e não será mais exibida"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.novaDivulgacaoForm.expiraEm,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.novaDivulgacaoForm,
                                      "expiraEm",
                                      $$v
                                    )
                                  },
                                  expression: "novaDivulgacaoForm.expiraEm"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "input-group" },
                            [
                              _c(
                                "label",
                                { staticClass: "field-label" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "primary" }
                                    },
                                    [_vm._v("mdi-image")]
                                  ),
                                  _vm._v(" Imagem "),
                                  !_vm.modoEdicao
                                    ? _c("span", { staticClass: "red--text" }, [
                                        _vm._v("*")
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              !_vm.modoEdicao
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption grey--text mb-2"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "", color: "info" }
                                        },
                                        [_vm._v("mdi-information")]
                                      ),
                                      _vm._v(
                                        " Imagem obrigatória para envio. Sem imagem, só é possível salvar como rascunho. "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "upload-zone mt-2",
                                  class: { dragover: _vm.isDragOver },
                                  on: {
                                    drop: _vm.onDrop,
                                    dragover: function($event) {
                                      $event.preventDefault()
                                      _vm.isDragOver = true
                                    },
                                    dragleave: function($event) {
                                      _vm.isDragOver = false
                                    },
                                    click: _vm.triggerFileSelect
                                  }
                                },
                                [
                                  !_vm.imagemPreview
                                    ? _c(
                                        "div",
                                        { staticClass: "upload-empty" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "48",
                                                color: "grey lighten-1"
                                              }
                                            },
                                            [_vm._v("mdi-cloud-upload")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-body-2 grey--text mt-2 mb-1"
                                            },
                                            [
                                              _vm._v(
                                                " Arraste uma imagem aqui ou clique para selecionar "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-caption grey--text"
                                            },
                                            [
                                              _vm._v(
                                                " JPG, PNG, GIF — até 5 MB "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "upload-preview" },
                                        [
                                          _c("img", {
                                            staticClass: "preview-img",
                                            attrs: {
                                              src: _vm.imagemPreview,
                                              alt: "Preview"
                                            }
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "upload-overlay" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "mr-2 btn-visualizar-imagem",
                                                  attrs: {
                                                    small: "",
                                                    color: "primary",
                                                    fab: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.visualizarImagemCompleta(
                                                        _vm.imagemPreview
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("mdi-magnify-plus")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "error",
                                                    fab: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removerArquivo.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [_vm._v("mdi-delete")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                ]
                              ),
                              _c("v-file-input", {
                                ref: "fileInput",
                                staticStyle: { display: "none" },
                                attrs: {
                                  accept: "image/jpeg,image/png,image/gif"
                                },
                                on: { change: _vm.onFileSelect },
                                model: {
                                  value: _vm.arquivoSelecionado,
                                  callback: function($$v) {
                                    _vm.arquivoSelecionado = $$v
                                  },
                                  expression: "arquivoSelecionado"
                                }
                              }),
                              _vm.nomeArquivo
                                ? _c(
                                    "div",
                                    { staticClass: "mt-2 d-flex align-center" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { small: "", color: "success" }
                                        },
                                        [_vm._v("mdi-check-circle")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text-body-2" },
                                        [_vm._v(_vm._s(_vm.nomeArquivo))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepAtual === 2,
                        expression: "stepAtual === 2"
                      }
                    ],
                    staticClass: "step-content pa-6"
                  },
                  [
                    _c("div", { staticClass: "step-title mb-4" }, [
                      _c("h3", { staticClass: "text-h6 font-weight-medium" }, [
                        _vm._v(" Configure os destinatários ")
                      ]),
                      _c("p", { staticClass: "text-body-2 grey--text mt-1" }, [
                        _vm._v(
                          " Escolha como enviar e adicione destinatários extras "
                        )
                      ])
                    ]),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "6" } },
                          [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-4",
                                attrs: {
                                  type: "info",
                                  outlined: "",
                                  dense: "",
                                  icon: "mdi-information"
                                }
                              },
                              [
                                _c("strong", [
                                  _vm._v("Todos os usuários ativos")
                                ]),
                                _vm._v(" receberão esta divulgação ")
                              ]
                            ),
                            _c("div", { staticClass: "input-group" }, [
                              _c(
                                "label",
                                { staticClass: "field-label" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "primary" }
                                    },
                                    [_vm._v("mdi-send")]
                                  ),
                                  _vm._v(" Métodos de envio * ")
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "method-cards mt-2" },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "method-card",
                                      class: {
                                        selected:
                                          _vm.novaDivulgacaoForm.enviarVia.email
                                      },
                                      attrs: { outlined: "" },
                                      on: { click: _vm.toggleEmail }
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex align-center"
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "ma-0 pa-0 mr-3",
                                                attrs: {
                                                  "hide-details": "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  change: _vm.validarMetodoEnvio
                                                },
                                                model: {
                                                  value:
                                                    _vm.novaDivulgacaoForm
                                                      .enviarVia.email,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.novaDivulgacaoForm
                                                        .enviarVia,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "\n                                                        novaDivulgacaoForm\n                                                            .enviarVia.email\n                                                    "
                                                }
                                              }),
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          color: "primary"
                                                        }
                                                      },
                                                      [_vm._v("mdi-email")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium"
                                                      },
                                                      [_vm._v("E-mail")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-caption grey--text ma-0 mt-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Envio por correio eletrônico "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "method-card mt-3",
                                      class: {
                                        selected:
                                          _vm.novaDivulgacaoForm.enviarVia.popup
                                      },
                                      attrs: { outlined: "" },
                                      on: { click: _vm.togglePopup }
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex align-center"
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "ma-0 pa-0 mr-3",
                                                attrs: {
                                                  "hide-details": "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  change: _vm.validarMetodoEnvio
                                                },
                                                model: {
                                                  value:
                                                    _vm.novaDivulgacaoForm
                                                      .enviarVia.popup,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.novaDivulgacaoForm
                                                        .enviarVia,
                                                      "popup",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "\n                                                        novaDivulgacaoForm\n                                                            .enviarVia.popup\n                                                    "
                                                }
                                              }),
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          color: "primary"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-message-alert"
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium"
                                                      },
                                                      [_vm._v("Pop-up")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-caption grey--text ma-0 mt-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Notificação na plataforma "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              !_vm.novaDivulgacaoForm.enviarVia.email &&
                              !_vm.novaDivulgacaoForm.enviarVia.popup
                                ? _c(
                                    "div",
                                    { staticClass: "error-text mt-2" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "", color: "error" }
                                        },
                                        [_vm._v("mdi-alert-circle")]
                                      ),
                                      _vm._v(
                                        " Selecione pelo menos um método de envio "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        ),
                        _c("v-col", { attrs: { cols: "12", lg: "6" } }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c(
                              "label",
                              { staticClass: "field-label" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { small: "", color: "primary" }
                                  },
                                  [_vm._v("mdi-account-plus")]
                                ),
                                _vm._v(" Destinatários extras ")
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "destinatarios-area mt-2" },
                              [
                                _vm.novaDivulgacaoForm.destinatariosAdicionais
                                  .length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "tags-container mb-3" },
                                      _vm._l(
                                        _vm.novaDivulgacaoForm
                                          .destinatariosAdicionais,
                                        function(email, index) {
                                          return _c(
                                            "v-chip",
                                            {
                                              key: index,
                                              staticClass: "ma-1",
                                              attrs: {
                                                close: "",
                                                small: "",
                                                color: "primary",
                                                "text-color": "white"
                                              },
                                              on: {
                                                "click:close": function(
                                                  $event
                                                ) {
                                                  return _vm.removerDestinatario(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { small: "", left: "" }
                                                },
                                                [_vm._v("mdi-email")]
                                              ),
                                              _vm._v(" " + _vm._s(email) + " ")
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                                _c("v-text-field", {
                                  staticClass: "destinatario-input",
                                  attrs: {
                                    placeholder: "adicionar@email.com",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "auto"
                                  },
                                  on: {
                                    keydown: [
                                      function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.adicionarDestinatario.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      _vm.onDestinatarioKeydown
                                    ]
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append",
                                      fn: function() {
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                color: "primary",
                                                disabled: !_vm.destinatarioInput.trim(),
                                                text: ""
                                              },
                                              on: {
                                                click: _vm.adicionarDestinatario
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-plus")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ]),
                                  model: {
                                    value: _vm.destinatarioInput,
                                    callback: function($$v) {
                                      _vm.destinatarioInput = $$v
                                    },
                                    expression: "destinatarioInput"
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticClass: "help-text mt-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "grey" } },
                                      [_vm._v("mdi-information")]
                                    ),
                                    _vm._v(
                                      " Adicione emails extras separados por vírgula ou Enter "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepAtual === 3,
                        expression: "stepAtual === 3"
                      }
                    ],
                    staticClass: "step-content pa-6"
                  },
                  [
                    _c("div", { staticClass: "step-title mb-4" }, [
                      _c("h3", { staticClass: "text-h6 font-weight-medium" }, [
                        _vm._v(" Revise antes de enviar ")
                      ]),
                      _c("p", { staticClass: "text-body-2 grey--text mt-1" }, [
                        _vm._v(
                          " Confira todas as informações da sua divulgação "
                        )
                      ])
                    ]),
                    _c(
                      "v-row",
                      { staticClass: "equal-height-row" },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", xl: "7", lg: "6" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "mb-4 resumo-divulgacao-card",
                                attrs: { outlined: "" }
                              },
                              [
                                _c(
                                  "v-card-title",
                                  { staticClass: "pb-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { color: "primary" }
                                      },
                                      [_vm._v("mdi-file-document")]
                                    ),
                                    _vm._v(" Resumo da Divulgação ")
                                  ],
                                  1
                                ),
                                _c("v-card-text", [
                                  _c(
                                    "div",
                                    { staticClass: "summary-item mb-3" },
                                    [
                                      _c("strong", [_vm._v("Assunto:")]),
                                      _c("p", { staticClass: "mt-1 mb-0" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.novaDivulgacaoForm.assunto
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "summary-item mb-3" },
                                    [
                                      _c("strong", [_vm._v("Imagem:")]),
                                      _vm.imagemPreview
                                        ? _c("div", { staticClass: "mt-1" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "summary-image mr-3",
                                                  attrs: {
                                                    src: _vm.imagemPreview,
                                                    alt: "Preview"
                                                  }
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "flex-grow-1"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text mb-2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.nomeArquivo
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "btn-visualizar-imagem",
                                                        attrs: {
                                                          color: "primary",
                                                          "x-small": ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.visualizarImagemCompleta(
                                                              _vm.imagemPreview
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              left: ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-magnify-plus"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" Visualizar ")
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ])
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-body-2 grey--text mt-1"
                                            },
                                            [
                                              _vm._v(
                                                " Nenhuma imagem selecionada "
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "summary-item mb-3" },
                                    [
                                      _c("strong", [
                                        _vm._v("Métodos de envio:")
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "mt-1" },
                                        [
                                          _vm.novaDivulgacaoForm.enviarVia.email
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    color: "primary",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        left: ""
                                                      }
                                                    },
                                                    [_vm._v("mdi-email")]
                                                  ),
                                                  _vm._v(" E-mail ")
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.novaDivulgacaoForm.enviarVia.popup
                                            ? _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "primary",
                                                    "text-color": "white"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        left: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-message-alert"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" Pop-up ")
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "summary-item mb-3" },
                                    [
                                      _c("strong", [
                                        _vm._v("Data de expiração:")
                                      ]),
                                      _c("p", { staticClass: "mt-1 mb-0" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatarDataExpiracao(
                                                _vm.novaDivulgacaoForm.expiraEm
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]
                                  ),
                                  _c("div", { staticClass: "summary-item" }, [
                                    _c("strong", [_vm._v("Destinatários:")]),
                                    _c(
                                      "p",
                                      { staticClass: "mt-1 mb-0 text-body-2" },
                                      [
                                        _vm._v(" Todos os usuários ativos "),
                                        _vm.novaDivulgacaoForm
                                          .destinatariosAdicionais.length > 0
                                          ? _c("span", [
                                              _vm._v(
                                                " + " +
                                                  _vm._s(
                                                    _vm.novaDivulgacaoForm
                                                      .destinatariosAdicionais
                                                      .length
                                                  ) +
                                                  " destinatário(s) adicional(is) "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", xl: "5", lg: "6" } },
                          [
                            _vm.novaDivulgacaoForm.assunto.trim() &&
                            (_vm.novaDivulgacaoForm.enviarVia.email ||
                              _vm.novaDivulgacaoForm.enviarVia.popup)
                              ? _c("div", [
                                  _c(
                                    "label",
                                    { staticClass: "field-label mb-3" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { small: "", color: "primary" }
                                        },
                                        [_vm._v("mdi-eye")]
                                      ),
                                      _vm._v(" Pré-visualização final ")
                                    ],
                                    1
                                  ),
                                  _vm.novaDivulgacaoForm.enviarVia.email
                                    ? _c(
                                        "div",
                                        { staticClass: "preview-email mb-4" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "preview-label" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "primary"
                                                  }
                                                },
                                                [_vm._v("mdi-email")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption font-weight-medium"
                                                },
                                                [
                                                  _vm._v(
                                                    "Como ficará o e-mail:"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "email-preview-container"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "email-header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "email-from"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " De: sistema@recuperi.com.br "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "email-subject"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Assunto: " +
                                                          _vm._s(
                                                            _vm
                                                              .novaDivulgacaoForm
                                                              .assunto ||
                                                              "Sem assunto"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "email-body" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "email-content"
                                                    },
                                                    [
                                                      _vm.imagemPreview
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "email-image"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "position-relative"
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "email-img cursor-pointer",
                                                                    attrs: {
                                                                      src:
                                                                        _vm.imagemPreview,
                                                                      alt:
                                                                        "Imagem anexa"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.visualizarImagemCompleta(
                                                                          _vm.imagemPreview
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "email-image-placeholder"
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey lighten-1"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-image"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey--text text-caption"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Imagem será exibida aqui"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.novaDivulgacaoForm.enviarVia.popup
                                    ? _c(
                                        "div",
                                        { staticClass: "preview-popup" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "preview-label" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "primary"
                                                  }
                                                },
                                                [_vm._v("mdi-message-alert")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption font-weight-medium"
                                                },
                                                [
                                                  _vm._v(
                                                    "Como ficará o pop-up:"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "popup-preview-container"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "popup-overlay"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "popup-content"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "popup-header"
                                                        },
                                                        [
                                                          _c(
                                                            "h4",
                                                            {
                                                              staticClass:
                                                                "popup-title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .novaDivulgacaoForm
                                                                      .assunto ||
                                                                      "Título da divulgação"
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "grey"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close"
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "popup-body"
                                                        },
                                                        [
                                                          _vm.imagemPreview
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "popup-image"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "position-relative"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "popup-img cursor-pointer",
                                                                          attrs: {
                                                                            src:
                                                                              _vm.imagemPreview,
                                                                            alt:
                                                                              "Imagem"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.visualizarImagemCompleta(
                                                                                _vm.imagemPreview
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "popup-image-placeholder"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey lighten-1",
                                                                        size:
                                                                          "40"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-image"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "grey--text text-caption"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Imagem será exibida aqui"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "popup-actions"
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  "primary",
                                                                text: ""
                                                              }
                                                            },
                                                            [_vm._v("Fechar")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "v-card-actions",
                {
                  staticClass: "modal-footer pa-6 d-flex justify-space-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "footer-left" },
                    [
                      _vm.stepAtual > 1
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-voltar",
                              attrs: { outlined: "", color: "primary" },
                              on: { click: _vm.voltarStep }
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-chevron-left")
                              ]),
                              _vm._v(" Voltar ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "footer-right d-flex" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-cancelar mr-3",
                          attrs: { outlined: "", color: "error" },
                          on: { click: _vm.cancelarModal }
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-close")
                          ]),
                          _vm._v(" Cancelar ")
                        ],
                        1
                      ),
                      _vm.stepAtual < 3
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-proximo mr-3",
                              attrs: {
                                color: "primary",
                                disabled: !_vm.podeAvancar
                              },
                              on: { click: _vm.avancarStep }
                            },
                            [
                              _vm._v(" Próximo "),
                              _c(
                                "v-icon",
                                { attrs: { right: "", small: "" } },
                                [_vm._v("mdi-chevron-right")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.stepAtual === 3
                        ? [
                            !_vm.modoEdicao
                              ? [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn-rascunho mr-3 white--text",
                                      attrs: {
                                        color: "#3B82F6",
                                        disabled: !_vm.novaDivulgacaoForm.assunto.trim()
                                      },
                                      on: { click: _vm.salvarRascunho }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-content-save")]
                                      ),
                                      _vm._v(" Salvar Rascunho ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-enviar white--text",
                                      attrs: {
                                        color: "#22C55E",
                                        disabled: !_vm.validarFormularioParaEnvio()
                                      },
                                      on: { click: _vm.confirmarEnvio }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-send")]
                                      ),
                                      _vm._v(" Enviar Agora ")
                                    ],
                                    1
                                  )
                                ]
                              : [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn-salvar-edicao mr-3 white--text",
                                      attrs: {
                                        color: "#3B82F6",
                                        disabled: !_vm.validarFormulario()
                                      },
                                      on: { click: _vm.salvarEdicaoRascunho }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-content-save")]
                                      ),
                                      _vm._v(" Salvar Edição ")
                                    ],
                                    1
                                  ),
                                  _vm.temImagemParaEnvio
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "btn-enviar-rascunho white--text",
                                          attrs: {
                                            color: "#22C55E",
                                            disabled: !_vm.validarFormularioParaEnvio()
                                          },
                                          on: {
                                            click: _vm.confirmarEnvioRascunho
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v("mdi-send")]
                                          ),
                                          _vm._v(" Enviar Agora ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialogConfirmacao,
            callback: function($$v) {
              _vm.dialogConfirmacao = $$v
            },
            expression: "dialogConfirmacao"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "modal-confirmacao" },
            [
              _c(
                "v-card-title",
                { staticClass: "justify-center pb-2 pt-6" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "warning--text mr-3",
                      attrs: { size: "32" }
                    },
                    [_vm._v(_vm._s(_vm.getConfirmacaoIcon()))]
                  ),
                  _c("h3", { staticClass: "text-h5 font-weight-medium" }, [
                    _vm._v(" " + _vm._s(_vm.getConfirmacaoTitulo()) + " ")
                  ])
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pa-6 text-center" }, [
                _c("p", { staticClass: "text-body-1 mb-4" }, [
                  _vm._v(" " + _vm._s(_vm.getConfirmacaoMensagem()) + " ")
                ]),
                _vm.tipoConfirmacao === "envio" ||
                _vm.tipoConfirmacao === "envio-rascunho"
                  ? _c("p", { staticClass: "text-body-2 grey--text" }, [
                      _c("strong", [
                        _vm._v("Isso enviará para todos os usuários ativos")
                      ]),
                      _vm.novaDivulgacaoForm.destinatariosAdicionais.length > 0
                        ? _c("span", [
                            _vm._v(
                              " + " +
                                _vm._s(
                                  _vm.novaDivulgacaoForm.destinatariosAdicionais
                                    .length
                                ) +
                                " destinatário(s) adicional(is) "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm.tipoConfirmacao === "edicao"
                  ? _c("p", { staticClass: "text-body-2 grey--text" }, [
                      _vm._v(
                        " As alterações serão salvas como rascunho e poderão ser enviadas posteriormente. "
                      )
                    ])
                  : _vm._e()
              ]),
              _c(
                "v-card-actions",
                { staticClass: "pa-6 pt-0 justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-3",
                      attrs: { outlined: "", color: "grey" },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacao = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: _vm.getConfirmacaoCor() },
                      on: {
                        click: function($event) {
                          return _vm.executarAcaoConfirmacao()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v(_vm._s(_vm.getConfirmacaoIcon()))
                      ]),
                      _vm._v(" " + _vm._s(_vm.getConfirmacaoBotao()) + " ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: _vm.snackbarColor,
              mensagemSnackbar: _vm.mensagemSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }